<template>
  <!-- 题库中心-最外层容器 -->
  <div class="page">
    <!-- 轮播图 -->
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  // 题库中心页面
  name: 'CompetitionCenter-QuestionBankCenter',
}
</script>
